import { render, staticRenderFns } from "./PlatformOrders.vue?vue&type=template&id=5dcd5819"
import script from "./PlatformOrders.vue?vue&type=script&lang=js"
export * from "./PlatformOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports